import {store} from '../store/store';
import {GamesList} from "./gameslist";


let GamesFunctions = {


    checkGames(ScannedMask) {


        let error = []

        let user = store.getters['getUser']

        user.event_mask.forEach(e => {

            let instance = GamesList.find(e => e.name === e.class).class

            let classGame = new instance()

            classGame.rules(ScannedMask)
        })


    }


}

export default GamesFunctions